import theme from '@styles/theme';
import { FLUID_SECTION_HORIZONTAL_PADDING_CSS } from '@utils/fluidSectionHorizontalPadding';
import { ThemeUIStyleObject } from 'theme-ui';
type StylesType = {
  section: (backgroundColor?: string) => ThemeUIStyleObject;
  container: ThemeUIStyleObject;
  header: ThemeUIStyleObject;
  title: ThemeUIStyleObject;
  sliderWrapper: ThemeUIStyleObject;
  productSlide: (useWhiteProductCard?: boolean) => ThemeUIStyleObject;
};
const styles: StylesType = {
  section: (backgroundColor?: string) => ({
    width: '100%',
    backgroundColor: backgroundColor || theme.rawColors.neutralWhite,
    overflow: 'hidden'
  }),
  container: {
    width: '100%'
  },
  header: {
    padding: FLUID_SECTION_HORIZONTAL_PADDING_CSS
  },
  title: {
    fontFamily: theme.fonts.uniformMedium,
    fontWeight: theme.fontWeights.medium,
    textTransform: 'uppercase',
    letterSpacing: '0.12em',
    lineHeight: '110%',
    color: theme.rawColors.neutralBlack,
    fontSize: [theme.fontSizes.h5,
    // mobile - 16px
    theme.fontSizes.h5,
    // mobilelg - 16px
    theme.fontSizes.h4,
    // tablet - 20px
    theme.fontSizes.h3,
    // tabletlg - 24px
    theme.fontSizes.h2,
    // desktop - 32px
    theme.fontSizes.h2 // widescreen - 32px
    ],
    margin: 0,
    whiteSpace: ['normal', 'normal', 'nowrap', 'nowrap', 'nowrap', 'nowrap']
  },
  sliderWrapper: {
    width: '100%',
    position: 'relative',
    padding: 0,
    '& .swiper .swiper-wrapper': {
      alignItems: 'stretch'
    },
    '& .swiper .swiper-slide': {
      height: 'auto !important'
    },
    '& .swiper .swiper-slide > div': {
      height: '100%'
    },
    '& .swiper .swiper-scrollbar': {
      position: 'absolute',
      bottom: 0,
      left: '0 !important',
      right: '0 !important',
      width: ['calc(100% - 32px) !important', 'calc(100% - 48px) !important', 'calc(100% - 64px) !important', 'calc(100% - 96px) !important', 'calc(100% - 128px) !important', 'calc(100% - 160px) !important'],
      maxWidth: 'calc(1920px - 160px)',
      margin: '0 auto !important',
      height: '24px !important',
      borderRadius: '0 !important',
      backgroundColor: 'transparent !important',
      cursor: 'grab',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: '11px',
        height: '2px',
        backgroundColor: theme.rawColors.lightGrey500,
        pointerEvents: 'none'
      },
      '&:active': {
        cursor: 'grabbing'
      }
    },
    '& .swiper .swiper-scrollbar-drag': {
      height: '5px !important',
      marginTop: '8px',
      backgroundColor: `${theme.rawColors.neutralBlack} !important`,
      borderRadius: '0 !important',
      cursor: 'grab',
      zIndex: 1,
      '&:active': {
        cursor: 'grabbing'
      }
    }
  },
  productSlide: (useWhiteProductCard = false) => {
    const sizes = ['186px', '186px', '246px', '308px', '342px', '454px'];
    return {
      width: sizes.map(s => `${s} !important`),
      minWidth: sizes.map(s => `${s} !important`),
      flexShrink: 0,
      height: '100%',
      display: 'flex',
      // ProductCard - wymiar z breakpointów
      '& [data-testid="ListingProductCard"]': {
        width: sizes.map(s => `${s} !important`),
        minWidth: sizes.map(s => `${s} !important`),
        maxWidth: sizes.map(s => `${s} !important`),
        height: '100%',
        flex: 1,
        flexShrink: 0,
        // Card background
        '& > div': {
          backgroundColor: useWhiteProductCard ? theme.rawColors.neutralWhite : 'transparent',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        },
        // Miniatura - breakpointy
        '& > div > div:first-of-type': {
          width: sizes.map(s => `${s} !important`),
          height: sizes.map(s => `${s} !important`),
          minWidth: sizes.map(s => `${s} !important`),
          minHeight: sizes.map(s => `${s} !important`),
          maxWidth: sizes.map(s => `${s} !important`),
          maxHeight: sizes.map(s => `${s} !important`),
          flexShrink: 0,
          backgroundColor: useWhiteProductCard ? theme.rawColors.neutralWhite : theme.rawColors.lightGreyBgProduct
        },
        // Product description - kontener z nazwą i ceną
        '& > div > div:last-of-type': {
          flexGrow: 1,
          minHeight: ['160px', '160px', '137px', '137px', '137px', '136.75px'],
          backgroundColor: theme.rawColors.neutralWhite,
          padding: ['8px 12px 16px', '8px 12px 16px', '10px 14px 18px', '12px 16px 20px'],
          // Product name
          '& > a': {
            fontFamily: theme.fonts.uniform,
            fontSize: ['16px', '16px', '16px', '16px'],
            fontWeight: theme.fontWeights.normal,
            letterSpacing: '0.02em',
            lineHeight: 1.3
          }
        },
        // Price
        '& [aria-label="Ceny produktu"], & [aria-label="productPricing"]': {
          paddingTop: '10px',
          '& a, & > span': {
            fontSize: ['14px', '14px', '15px', '16px'],
            letterSpacing: '0.03em'
          },
          '& small': {
            fontSize: ['10px', '10px', '11px', '12px']
          }
        },
        // Colors
        '& [aria-label="Dostępne kolory"], & [aria-label="availableColors"]': {
          fontFamily: theme.fonts.uniformExtra,
          marginTop: '8px',
          display: 'flex !important',
          alignItems: 'center !important',
          fontWeight: `${theme.fontWeights.bold} !important`,
          fontSize: ['12px', '12px', '13px', '13px'],
          letterSpacing: '1px',
          '& > span, & > a': {
            display: 'inline-flex !important',
            alignItems: 'center !important'
          },
          '& span[role="img"]': {
            marginRight: '5px !important',
            border: 'none !important'
          }
        }
      }
    };
  }
};
export default styles;